import {
  Typography,
  Button,
  Chip,
  CardContent,
  CardActions,
  Stack,
} from '@mui/material';
import React, { FC } from 'react';
import { Typography700, ImgBox } from 'views/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import CheckIcon from '@mui/icons-material/Check';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import StyledCard from 'views/rebranded-module/common/components/UI/PlanCardV2/PlanCardV2.styles';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import { useSelector } from 'redux/app/store';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const PlanCardV2 = (props) => {
  const {
    plan, cardActions = true, handleJoinNowBtnClick, gifted,
  } = props;
  const content = useContent('PlanCardComponent');

  const isSilver = plan.isSilver || false;
  const appState = useSelector((state) => state.globalData.appState);
  const appNavigator = useAppNavigator();
  const getURLParam = () => {
    const urlParam = appNavigator.query.referral_code
      ? {
        membership_id: plan.id,
        referral_code: appNavigator.query.referral_code,
      }
      : {
        membership_id: plan.id,
      };

    if (gifted) {
      return {
        ...urlParam,
        gifted: 1,
      };
    }
    return urlParam;
  };
  return (
    <StyledCard className={`PCCardRoot${isSilver ? ' PCSilverPlanCard' : ''}`}>
      <CardContent className="PCCardContent">
        {isSilver && (
          <Chip className="PCChip" label={content.mostPopularLabel} />
        )}
        <Stack flexDirection="row" justifyContent="space-between" py={2}>
          <Stack gap={1.5}>
            <Typography700 variant="h6" component="p">
              {plan.name}
            </Typography700>
            <Typography700
              variant="h1"
              component="p"
              className="PCplanPrice"
              dangerouslySetInnerHTML={{
                __html: interpolateString(content.planPrice, {
                  price: plan.price,
                }),
              }}
            />
            <Typography500 variant="body2" component="p" color="text.secondary">
              {content.membershipNameSubtitle}
            </Typography500>
          </Stack>
          {plan.logo&&(
          <ImgBox
            imgWidth="70px"
            imgHeight="80px"
            imgObjectFit="contain"
            className="PCPlanLogo"
            image={{
              src: plan.logo,
              alt: `${plan.name} logo`,
            }}
          />
          )}
        </Stack>
        <Stack gap={1}>
          {plan.benefits?.map((benefit, index) => (
            <Typography key={index} variant="body2" display="flex" gap={1}>
              <CheckIcon />
              {interpolateString(benefit.benefitText, {
                rental_credits_count: plan.rentalCredits,
                buddy_pass_count: plan.buddyCount,
                initiation_fee: plan.initiationFee,
              })}
            </Typography>
          ))}
        </Stack>
      </CardContent>

      {cardActions && (
        <CardActions className="PCCardActions">
          <Button
            className="PCAction"
            variant={plan.buttonVariant}
            color={plan.buttonColor}
            size="large"
            fullWidth
            onClick={handleJoinNowBtnClick}
            component={NavigatorLink}
            href={
              !handleJoinNowBtnClick
              && (appState.current_user
                ? PATHS.motorcycleClub.checkout(getURLParam())
                : PATHS.motorcycleClub.signUp(getURLParam()))
            }>
            {interpolateString(content.planCTAButton, { name: plan.name })}
          </Button>
        </CardActions>
      )}
    </StyledCard>
  );
};

export { PlanCardV2 };
